import styled from 'styled-components'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import { useSelector } from 'react-redux'

const Container=styled.div`
	display:flex;
	align-items:center
 `;

let Usuario=styled.div`
	font-weight:500
`;


 export default function NavigationClient(){
 	const [value, setValue] = useState(0);
 	const estadoReventas=useSelector(state=>state.reventa.reventasEstado);
 	const usuario=useSelector(state=>state.login.user);



 	const handleChange=(e,newValue)=>{ setValue(newValue)	};
 
 	return(
 		<Container>
 			<Usuario>{usuario.name}</Usuario> 
 			<Box >
	     		<Tabs value={value} disabled={true} onChange={handleChange}  style={{ textDecoration: "none" }} textColor="primary" indicatorColor="primary" allowScrollButtonsMobile scrollButtons variant="scrollable" >
        			<Tab disabled={estadoReventas!==0?true:false}  label="juegos" to="/dashboard/juegos" component={NavLink} />
        			<Tab disabled={estadoReventas!==0?true:false}  label="reventas" to="/dashboard/reventas" component={NavLink} />
        		</Tabs>
      		</Box>
 			
 		</Container>
 		)
 }